import React, { createContext, useContext } from 'react'
import PropTypes from 'prop-types'

// This context is used to pass down documents configs from the ruby server
// avoiding props-drilling
const documentsConfigContext = createContext()

export const useDocumentsConfig = () => useContext(documentsConfigContext)

function DocumentsConfigProvider({
  children,
  preventMarkAsNotRequired = false,
  ...restOfConfigs
}) {
  return (
    <documentsConfigContext.Provider
      value={{ preventMarkAsNotRequired, ...restOfConfigs }}
    >
      {children}
    </documentsConfigContext.Provider>
  )
}

DocumentsConfigProvider.propTypes = {
  children: PropTypes.node.isRequired,
  hideArchivedFiles: PropTypes.bool.isRequired,
  superUser: PropTypes.bool.isRequired,
  bankAdmin: PropTypes.bool.isRequired,
  bankProcessor: PropTypes.bool.isRequired,
  customerService: PropTypes.bool.isRequired,
  fileRenamingEnabled: PropTypes.bool.isRequired,
  preventMarkAsNotRequired: PropTypes.bool,
}

export default DocumentsConfigProvider
